import { createFormatters } from 'app/infrastructure/data/date';

export enum substanceCodetableIds {
  uomSets = 398,
  hierarchy = 341,
  category = 351
}

export const unitOfMeasureTypeId = 334;

export const unitOfMeasureExcludeId = 3699;

export const userGroupCodetableId = 19;

export const defaultUomConversionFactor = 1;

export const duplicateTranslationSuffixNumber = 2;

export const duplicateSuffix = (locale: string) => createFormatters(locale).formatNumber(duplicateTranslationSuffixNumber, {});

export const maxIconLength = 80;

export enum HierarchyCodetableIds {
  ActionCategory = 269,
  ActivityType = 332,
  AuditType = 274,
  BarrierCategory = 396,
  BarrierElement = 385,
  BarrierFunction = 381,
  BarrierSystem = 392,
  CaseCategory = 102,
  Causes = 103,
  CheckListHierarchy = 266,
  Chemical = 105,
  ConsumptionType = 333,
  Diagnosis = 286,
  Drug = 282,
  Equipment = 36,
  FailureType = 267,
  Hazard = 395,
  HazardousEvent = 389,
  ImmediateAction = 291,
  IndicatorType = 239,
  InfectionFinding = 296,
  InfectionType = 293,
  InspectionType = 275,
  LifecyclePhase = 357,
  PerformanceStandard = 386,
  Product = 129,
  ReferenceOption = 446,
  RuleAndRegulation = 110,
  SecurityBreachType = 243,
  Shutdown = 136,
  SpillType = 139,
  SystemInvolved = 143,
  TreatmentChain = 273,
  Unit = 31,
  WorkProcess = 35,
  Location = 34
}
